// The properties a reported view carries. `page` is the name analytics groups its
// reports by, and a website that owns the page is named alongside it so that two
// customers looking at the same page are told apart.
//
export default function makeEventProperties({ properties, trackingName, websiteID }) {
  const eventProperties = {
    ...properties,
    page: trackingName,
  }

  if ( websiteID ) {
    eventProperties.website_id = websiteID
  }

  return eventProperties
}
